const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');

class CloverTransactionGetPaymentByExternalPaymentIdRequestRecord extends AbstractCloverRequestRecord {
    /**
     * Check if a payment exists and if so return it using the externalPaymentId (which is the same as idempotency key).
     * We call this after cancelling, so we can see if the cancel was successful or if the customer had already managed
     * to pay before the cancellation request.
     *
     * @param {string} externalPaymentId
     */
    constructor(externalPaymentId) {
        if (!externalPaymentId || externalPaymentId.trim() === '') {
            throw new Error('externalPaymentId is required');
        }
        // @link https://docs.clover.com/reference/get_payment_by_external_payment_id
        const url = '/connect/v1/payments/external/' + externalPaymentId;
        super(
            'GET',
            url
        );
    }
}

module.exports = CloverTransactionGetPaymentByExternalPaymentIdRequestRecord;
